module.exports = __webpack_public_path__ + "img/cliente-3.709fb285.jpg";